import { render, staticRenderFns } from "./InvoiceLain.vue?vue&type=template&id=ebfc2b28&scoped=true&"
import script from "./InvoiceLain.vue?vue&type=script&lang=js&"
export * from "./InvoiceLain.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceLain.vue?vue&type=style&index=0&id=ebfc2b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfc2b28",
  null
  
)

export default component.exports